import { Button, Dialog } from 'primereact'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { getListaEvaluacionPersonal } from '../../../../API/Gerencia/Procedimientos/Evaluaciones/EvaluacionesRequets'
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid'
import { exportarExcel } from '../../../../Base/Services/ArchivosService'
import { getPersonal } from '../../../../API/RRHH/Personal/PersonalRequests'
import { getEvaluacionByIdProcedimiento, getPreguntaByIdEvaluacion, getRespuestas } from '../../../../API/Gerencia/Procedimientos/ProcedimientosRequets'
import { TabView, TabPanel } from 'primereact/tabview'
import CardPreguntaDinamica from '../CardPreguntaDinamica';

const EvaluacionListScreen = ({ procedimientoSelect }) => {

  const [personal, setPersonal] = useState([]);
  const [lisRespuestas, setListRespuestas] = useState([]);
  const [contestadas, setContestadas] = useState(0);
  const [aprobados, setAprobados] = useState(0);
  const [loading, setLoading] = useState(false);
  const [preguntas, setPreguntas] = useState([]);

  const getInfo = async () => {
    setLoading(true);
    const t = await getListaEvaluacionPersonal(procedimientoSelect?.idProcedimiento);
    let pa = await getPersonal();

    pa = pa.map(e => {
      return {
        ...e,
        IdPersonal: e.idpersonal,
        FechaRespuesta: t.find(f => f.IdPersonal === e.idpersonal)?.FechaRespuesta,
        CORRECTAS: t.find(f => f.IdPersonal === e.idpersonal)?.CORRECTAS ? t.find(f => f.IdPersonal === e.idpersonal)?.CORRECTAS : 0,
        TOTAL: t.find(f => f.IdPersonal === e.idpersonal)?.TOTAL ? t.find(f => f.IdPersonal === e.idpersonal)?.TOTAL : 0

      }
    })

    let a = pa.map(e => {
      return {
        ...e,
        Calificacion: ((e.CORRECTAS / e.TOTAL) * 100).toFixed(0)
      }
    })

    a = a.sort((a, b) => a.CORRECTAS - b.CORRECTAS).reverse();

    const contes = a.filter(e => e?.FechaRespuesta);
    const apro = a.filter(e => e?.Calificacion == 100);
    setContestadas(contes.length);
    setAprobados(apro.length);


    setPersonal(a);
    setLoading(false);
  }

  const getRespuestasEvaluacion = async () => {
    setLoading(true);
    const evaluacion = await getEvaluacionByIdProcedimiento(procedimientoSelect.idProcedimiento);
    const IdEvaluacion = evaluacion[0]?.IdEvaluacion;

    const preguntas = await getPreguntaByIdEvaluacion(IdEvaluacion);
    setPreguntas(preguntas);

    let todasRespuestas = [];

    for (const pregunta of preguntas) {
      const respuestas = await getRespuestas(pregunta.IdPregunta);
      console.log(respuestas);
      const respuestasConPregunta = respuestas.map(res => ({
        ...res,
        Pregunta: pregunta.Pregunta,
        TipoPregunta: pregunta.TipoPregunta
      }));
      todasRespuestas = todasRespuestas.concat(respuestasConPregunta);
    }

    setListRespuestas(todasRespuestas);
    setLoading(false);
  };


  const obtenerInfo = () => {
    getInfo();
    getRespuestasEvaluacion();
  }

  const Nota = (row) => {
    // console.log(row);
    let a = personal.reduce((p, n) => p + n, 0)
    // console.log(personal.reduce((p,n) => p + n.CORRECTAS,0));
    if (row.idpersonal && row.Calificacion > 0) {
      return <div style={{ textAlign: 'end', color: row.CORRECTAS === row.TOTAL ? 'green' : 'red', fontWeight: row.CORRECTAS === row.TOTAL ? '600' : '900' }}>
        {(row.Calificacion)}%
      </div>
    } else {
      return ''
    }
  }

  const columns = [
    {
      header: 'Codigo',
      field: 'IdPersonal',
      className: 'Xsmall'
    },
    {
      header: 'Nombre',
      field: 'NombreEmpleado',
      className: 'XXlarge',
      Sumary: 'count'
    },
    {
      header: 'Posicion',
      field: 'posicion',
    },
    {
      header: 'Seccion',
      field: 'seccion',
    },
    {
      header: 'Correo',
      field: 'Correo',
    },
    {
      header: 'Fecha',
      field: 'FechaRespuesta',
      Format: 'Date'
    },
    {
      header: 'CORRECTAS',
      field: 'CORRECTAS',
      className: 'XXsmall'
    },

    {
      header: 'Calificación',
      field: 'Calificacion',
      Format: 'Template',
      body: e => Nota({ ...e, AVG: true }),
      className: 'Xsmall',
      filter: true,
      Type: 'numberColumn',
      Sumary: 'avg'
    },

  ]

  const table = {
    Data: personal,
    Columns: columns,
    loading: loading
  }


  const columnsRespuestas = [
    {
      header: 'Codigo Personal',
      field: 'IdPersonal',
      className: 'small'
    },
    {
      header: 'Nombre Personal',
      field: 'NombreEmpleado',
      className: 'XXlarge',
      Sumary: 'count'
    },
    {
      header: 'Sección',
      field: 'seccion',
      className: 'large',
      Sumary: 'count'
    },
    {
      header: 'Pregunta',
      field: 'Pregunta',
      className: 'XXlarge',
    },
    {
      header: 'No. Respuesta',
      field: 'RespuestaInt',
      className: 'small',
      Sumary: 'count'
    },
    {
      header: 'Respuesta',
      field: 'RespuestaTexto',
      flex: 1,
    },
  ]

  const tableRespuestas = {
    Data: lisRespuestas,
    Columns: columnsRespuestas,
    loading: loading
  }

  useEffect(() => {
    if (procedimientoSelect) {
      getInfo();
      getRespuestasEvaluacion();
    }
  }, [procedimientoSelect])

  const respuestasEvaluacion6 = lisRespuestas.some(r => r.IdEvaluacion === 6);

  const agruparPorPregunta = (respuestas) => {
    const agrupado = {};
    respuestas.forEach(resp => {
      const pregunta = resp.Pregunta || 'Pregunta desconocida';
      if (!agrupado[pregunta]) {
        agrupado[pregunta] = [];
      }
      agrupado[pregunta].push(resp);
    });
    return agrupado;
  };

  const agrupadas = agruparPorPregunta(lisRespuestas);
  const cantidadEncuestasLlenadas = Object.values(agrupadas)[0]?.length || 0;

  return (
    <div style={{ height: '95%' }} className='d-flex'>
      <div className='col-10'>
        <TabView>
          <TabPanel header="Personal">
            <div style={{ height: '70vh' }}>
              <AgGrid table={table} />
            </div>
          </TabPanel>

          {respuestasEvaluacion6 && (
            <TabPanel header="Respuestas">
              <div style={{ height: '70vh' }}>
                <AgGrid table={tableRespuestas} />
              </div>
            </TabPanel>
          )}

          <TabPanel header="Gráficas">
            <div style={{ height: '70vh', overflowY: 'auto', padding: '1rem' }}>
              {Object.entries(agrupadas).map(([pregunta, respuestas], i) => {
                let TipoPregunta = respuestas[0]?.TipoPregunta;
                console.log({ respuestas });
                switch (TipoPregunta) {
                  case "1":
                    return (
                      <CardPreguntaDinamica
                        key={i}
                        preguntaTexto={pregunta}
                        respuestas={respuestas}
                        index={i}
                      />
                    )
                    break;
                  case "2":
                    return (<div>
                      <h4>{pregunta}</h4>
                      {respuestas.map((r, j) => (
                        <div key={j}>
                          <p>{j + 1}. {r.RespuestaChar}</p>
                        </div>
                      ))}
                    </div>
                    )
                    break;
                  default:
                    break;
                }
              }
              )}
            </div>
          </TabPanel>
        </TabView>
      </div>

      <div className='p-5' style={{ textAlign: 'end' }} >
        <Button className='p-button-rounded p-button-text' icon='pi pi-refresh' onClick={obtenerInfo} />
        <Button className='p-button-rounded p-button-text' icon='pi pi-file-excel' onClick={e => exportarExcel(table, procedimientoSelect?.Procedimiento)} />
        <p>Completado: <span style={{ fontWeight: 800 }}>{contestadas || cantidadEncuestasLlenadas}</span></p>
        {aprobados !== 0 && (
          <div>
            <p>Aprobados: <span style={{ fontWeight: 800 }}>{aprobados}</span></p>
            <p>Reprobados: <span style={{ fontWeight: 800, color: 'red' }}>{contestadas - aprobados}</span> </p>
            <p>Faltantes: <span style={{ fontWeight: 800 }}>{personal.length - contestadas}</span></p>
          </div>
        )}
      </div>
    </div>
  )
}

export default EvaluacionListScreen
